<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns="http://www.w3.org/1999/html">
  <div class="author-list">
    <div
      class="author-item"
      :class="!small?'small-author':''"
      v-for="item in itemList"
      :key="item.userId"
    >
      <div class="author-info">
        <router-link :to="'/peopleCenter/'+item.userId" target="_blank">
          <img
            class="author-avatar"
            :src="item.avatar | imageUrl('/static/profile_img_default.png', 150, 150)"
          />
        </router-link>
        <div class="author-content">
          <router-link :to="'/peopleCenter/'+item.userId" target="_blank">
            <div class="author-name">{{item.nickname}}</div>
          </router-link>
          <div class="author-title">
            <strong v-if="item.area">{{$t('global.地区')}}：</strong>
            {{item.area}}
          </div>
          <div class="author-title">
            <strong v-if="item.field">{{$t('global.领域')}}：</strong>
            {{item.field}}
          </div>
          <button
            class="author-focus"
            @click="Follow(item)"
          >{{!item.isFollow?$t('global.关 注'):$t('global.取消关注')}}</button>
        </div>
      </div>
      <div class="author-video" :class="{fourth: small}">
        <div
          class="author-video-item"
          v-for="subitem in item.items.slice(0,small?4:3)"
          :key="subitem.videoId"
        >
          <router-link :to="'/video/detail?id='+subitem.videoId" target="_blank">
            <img :src="subitem.thumb | imageUrl('',344,194)" />
            <p>{{subitem.title}}</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    itemList: Array,
    small: Boolean
  },
  created: function() {},
  mounted: function() {},
  updated: function() {},
  destroyed: function() {},
  methods: {
    Follow(item) {
      let that = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(function(response) {
          if (response) {
            item.isFollow = !item.isFollow;
            that.$message(response.message);
            that.$emit("follow", item);
          }
        });
    }
  }
};
</script>
<style scoped>
.author-item {
  position: relative;
  height: 138px;
  overflow: hidden;
  zoom: 1;
  border-bottom: 1px solid #dddddd;
  padding: 0.49rem 586px 0.49rem 0;
}
.author-item:last-child {
  border-bottom: none;
}
.author-info {
  margin-right: 50px;
  overflow: hidden;
  zoom: 1;
  display: flex;
  align-items: center;
}

.author-avatar {
  width: 75px;
  height: 75px;
  float: left;
  display: block;
  margin: auto;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.author-content {
  float: left;
  width: calc(100% - 85px);
  padding-left: 10px;
  padding-top: 5px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.author-name {
  font-size: 0.26rem;
  font-weight: bold;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.author-title {
  font-size: 0.14rem;
  color: #777777;
  margin-top: 0.06rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.author-title > strong {
  color: #000;
}

.author-focus {
  display: block;
  width: 70px;
  height: 30px;
  padding: 0;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  background-color: #0060ff;
  border-radius: 2px;
  margin-top: 0.2rem;
}

.author-video {
  position: absolute;
  top: 0.49rem;
  right: 0;
  width: 536px;
  margin: 5px 0 0 0;
  align-items: center;
}

.author-video-item {
  float: left;
  width: 172px;
  margin-right: 10px;
  box-sizing: border-box;
}
.author-video-item:nth-child(3) {
  margin-right: 0;
}
.author-video-item:nth-child(n + 4) {
  display: none;
}
.author-video-item img {
  width: 100%;
  height: 97px;
  display: block;
}
.author-video-item a {
  color: #333;
}
.author-video-item p {
  display: -webkit-box;
  height: 36px;
  margin-top: 5px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.small-author {
  width: auto;
}

.small-author .author-content {
  width: auto;
}

/*.small-author .author-info {
  width: auto;
}*/

.small-author .author-video-item img {
  height: 97px;
}

.fourth {
  margin-top: 5px;
}

.container-my-focus .small-author .author-content {
  width: 140px;
}

.container-my-focus .author-info {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/author/AuthorList.vue